import React from 'react'
import FileItem from './FileItem'

export default class FileListForm extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        file_order_id: props.order.order_id
      },
      errors: {},
      adding: false
    };
  }

  startAdd = () => {
    this.setState({adding:true});
  }

  cancelAdd = () => {
    this.setState({adding:false});
  }

  handleUpload = e => {
    e.preventDefault();
    if (this.fileInput.files[0].size > 2097152) {
      this.setState({errors: {form: 'Размер файла больше двух мегабайтов'}});
      return;
    }
    const parts = this.fileInput.files[0].name.split('.');
    const extension = parts.pop();
    const desc = parts.join('.');
    const date = new Date();
    const formatedDate = date.toISOString();
    this.props.editFile({
      file_order_id: this.props.order.order_id,
      file_data: this.fileInput.files[0],
      file_size: this.fileInput.files[0].size,
      file_desc: desc,
      file_extension: extension,
      file_date: formatedDate,
      file_active: 1,
      file_note: ''
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.setState({
        errors: {},
        adding: false
      });
    });
    // console.log(this.fileInput.files);
  }

  render() {

    const { files, order, editFile, filetypes, filetypeId } = this.props;
    const { adding, errors } = this.state;

    const filteredData = files.filter(el => {
      return (
        el.file_active === 1 && (
          filetypeId === 0 || el.file_filetype_id === filetypeId
        )
      );
    });

    const mappedData = filteredData.map( el => {
      return <FileItem
        editFile={editFile}
        order={order}
        key={el.file_id}
        file={el}
        filetypes={filetypes}
      />
    });

    const addFileForm = adding ?
      <tr>
        <td colSpan="5">
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          <div style={{display: 'inline-block'}}>
            <input
              type="file"
              ref={input => {this.fileInput = input;}}
            />
        </div>
          <button onClick={this.handleUpload}>Загрузить</button>
        </td>
      </tr> :
      <tr onClick={this.startAdd} >
        <td colSpan="5"><u>Добавить файл</u></td>
      </tr>;

    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th className="col-sm-5">Имя</th>
              <th className="col-sm-2">Тип</th>
              <th className="col-sm-1">Добавлен</th>
              <th className="col-sm-1 text-right">Размер, kb</th>
              <th className="col-sm-3">Заметка</th>
            </tr>
          </thead>
          <tbody>
            {mappedData}
            {addFileForm}
          </tbody>
        </table>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/order/FileListForm.js